import { createApiCall } from 'lib/base';

const FETCH_STOCK_EVENT_EDIT_API_ID = 'DASHBOARD/FETCH_STOCK_EVENT_EDIT_API';

const apiCall = createApiCall(FETCH_STOCK_EVENT_EDIT_API_ID, ({ id, payload }) => ({
  endpoint: `/api/admin/stock-events/${id}`,
  method: 'PATCH',
  body: payload,
  notify: true,
}));

export default apiCall;
